export default "__VITE_ASSET__Dz40MhPE__"